import React from 'react';

interface TrustpilotComponentProps {
	templateId: string;
	businessUnitId: string;
	styleHeight?: string;
	styleWidth?: string;
	theme: string;
	stars: string;
	reviewLanguages?: string;
	url: string;
}

export const TrustpilotComponent: React.FC<TrustpilotComponentProps> = ({
	templateId,
	businessUnitId,
	styleHeight = '140px',
	styleWidth = '100%',
	theme,
	stars,
	reviewLanguages = 'da',
	url,
}) => {
	const ref = React.useRef(null);

	React.useEffect(() => {
		// Load the Trustpilot widget
		const loadTrustpilotWidget = () => {
			if (globalThis.Trustpilot) {
				globalThis.Trustpilot.loadFromElement(ref.current, true);
			}
		};

		// Check if Trustpilot script is already loaded
		if (globalThis.Trustpilot) {
			loadTrustpilotWidget();
		} else {
			// Load the Trustpilot script
			const script = document.createElement('script');
			script.type = 'text/javascript';
			script.src = 'https://widget.trustpilot.com/bootstrap/v5/tp.widget.bootstrap.min.js';
			script.async = true;
			script.onload = loadTrustpilotWidget;
			document.head.appendChild(script);

			// Cleanup function to remove the script when component unmounts
			return () => {
				if (script.parentNode) {
					script.remove();
				}
			};
		}
	}, []);
	return (
		<div
			ref={ref}
			className="trustpilot-widget"
			data-locale="da-DK"
			data-template-id={templateId}
			data-businessunit-id={businessUnitId}
			data-style-height={styleHeight}
			data-style-width={styleWidth}
			data-theme={theme}
			data-stars={stars}
			data-review-languages={reviewLanguages}
		>
			<a href={url} target="_blank" rel="noopener noreferrer">
				Trustpilot
			</a>
		</div>
	);
};
